import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ELSODateTimePickerComponent } from '../customComponents/elso-datetimepicker/elso-datetimepicker.component';
import { AngularMaterialModule } from './angular-material.module';
//import { OwlDateTimeModule, OwlNativeDateTimeModule, DateTimeAdapter } from 'ng-pick-datetime';
import { OwlDateTimeModule, OwlNativeDateTimeModule, DateTimeAdapter } from '@danielmoncada/angular-datetime-picker';
import { CustomOwlDateTimeAdapter } from '../classes/owlCustomDateAdapterr';
import { ELSOInputComponent } from '../customComponents/elso-input/elso-input.component';
import { ValidateMinMaxNumberDirective } from '../directives/validate-minmax-number.directive';
//import { MdePopoverModule } from '@material-extended/mde';
import { ValidateDateDirective } from '../directives/validate-date.directive';
import { DateFormatPipe } from '../pipes/date-format.pipe';
import { ELSOFilterPipe } from '../pipes/elso-grid-filter.pipe';
import { ELSOHospitalizationFilterPipe } from '../pipes/elso-grid-hospitalization-filter.pipe';

import { PaginatorService } from '../services/paginator.service';
import { UnitValueConversionPipe } from '../pipes/univ-value-conversion.pipe';
import { TooltipDirective } from '../directives/tooltip.directive';
import { MinMaxTooltipComponent, TooltipContainerDirective } from '../components/tooltip/tooltip.component';
import { ValidateNumberPrecisionDirective } from '../directives/validate-number-precision.directive';
import { UnitValueConversionDirective } from '../directives/unit-value-conversion.directive';
import { OwlMomentDateTimeModule, OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, MomentDateTimeAdapter } from '@danielmoncada/angular-datetime-picker-moment-adapter';

@NgModule({
  imports: [
    CommonModule,
    AngularMaterialModule,
    FormsModule,
    ReactiveFormsModule,
    OwlDateTimeModule,
    //OwlNativeDateTimeModule,
    OwlMomentDateTimeModule
    //MdePopoverModule
  ],
  declarations: [
    ELSODateTimePickerComponent,
    ELSOInputComponent,
    ValidateMinMaxNumberDirective,
    ValidateDateDirective,
    DateFormatPipe,
    ELSOFilterPipe,
    ELSOHospitalizationFilterPipe,
    UnitValueConversionPipe,

    TooltipDirective,
    TooltipContainerDirective,
    MinMaxTooltipComponent,
    UnitValueConversionDirective,
    ValidateNumberPrecisionDirective,
  ],
  exports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    ELSODateTimePickerComponent,
    ELSOInputComponent,
    ValidateMinMaxNumberDirective,
    ValidateDateDirective,
    DateFormatPipe,
    ELSOFilterPipe,
    ELSOHospitalizationFilterPipe,
    UnitValueConversionPipe,
    TooltipDirective,
    TooltipContainerDirective,
    MinMaxTooltipComponent,
    UnitValueConversionDirective,
    ValidateNumberPrecisionDirective,
  ],
  providers: [
    CustomOwlDateTimeAdapter, // so we could inject services to 'CustomDateAdapter'
    //{
    //  provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS,
    //  useValue: {
    //    useUtc: true
    //  }
    //},
    { provide: DateTimeAdapter, useClass: CustomOwlDateTimeAdapter }, // Parse MatDatePicker Format // if not commented it wont work with plain type owl date picker
    PaginatorService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class SharedModule{


}
